import React from "react";
import { Navigate, Outlet } from "react-router-dom";
function Protected({ route, user }) {
  const hasToken =
    sessionStorage.getItem("_t") || localStorage.getItem("_t");
  const isAuthinticated = Boolean(user && hasToken);
  const isAuthorized = route.role.includes(user?.role);
  const reDirect = sessionStorage.getItem("reDirect_url");

  if (!isAuthinticated || !isAuthorized) {
    return <Navigate to="/login" replace />;
  }
  else if (reDirect) {
      sessionStorage.removeItem('reDirect_url')
      return <Navigate to={reDirect} replace />
  }
  else {
    return <Outlet />;
  }
}
export default Protected;
